export const contactsData = {
    email: 'biswajitchikal847@gmail.com',
    phone: '+919114240557',
    address: 'Jagatsinghpur, Odisha',

    sheetAPI: ''
}